import { useMemo, useCallback } from 'react';
// import { RepeatQuestionResponsesContainer } from '@containers/RepeatSurveyResponses/QuestionResponsesContainer';
import type { BaseProjectSurvey } from '@trinity/chat/types/project-surveys';
// import { useProjectOrLatestChild } from '@/containers/GroupProject/hooks';
import { SurveyResponseFilterContainer } from '@/components/SurveyResponseFilter';
import { SurveyQuerySelector } from '@/components/SurveySelector';
// import { SurveyActions } from './SurveyActions';
import styles from './styles/SurveyResponsesContainer.module.css';

type Props = {
  children: React.ReactNode;
} & IProjectId;

export const SurveyResponsesContainer = (props: Props) => {
  return (
    <SurveyQuerySelector
      projectId={props.projectId}
      classes={{ dropdownContainer: styles.dropdownContainer }}
      ActionsComponent={ActionsComponent}>
      {props.children}
    </SurveyQuerySelector>
  );
};

const ActionsComponent = ({ survey }: { survey: BaseProjectSurvey }) => {
  // const project = useProjectOrLatestChild();

  return (
    <div className={styles.actions}>
      <SurveyResponseFilterContainer />
      {/* <SurveyActions survey={survey} project={project} /> */}
    </div>
  );
};